import { render, staticRenderFns } from "./terveyskeskuskoulutusjakson-hyvaksyntapyynto.vue?vue&type=template&id=16cf1599&scoped=true&"
import script from "./terveyskeskuskoulutusjakson-hyvaksyntapyynto.vue?vue&type=script&lang=ts&"
export * from "./terveyskeskuskoulutusjakson-hyvaksyntapyynto.vue?vue&type=script&lang=ts&"
import style0 from "./terveyskeskuskoulutusjakson-hyvaksyntapyynto.vue?vue&type=style&index=0&id=16cf1599&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cf1599",
  null
  
)

export default component.exports